
import Grid from '@mui/material/Grid2'
import { ButtonBlueStyle } from "../Theme/ButtonStyle";


export const ButtonConfirmCustom = (props) => {
  const {onClickConfirm, onClickCancel} = props
  return (
    <Grid size={12} container justifyContent="center" sx={{ mt: 1 }} columnSpacing={1}>
      <Grid item size={6} >
        <ButtonBlueStyle id="closeVariablesModalButton"
                          fullWidth variant='contained' 
                          onClick={onClickCancel}>
          Annulla
        </ButtonBlueStyle>
      </Grid>
      <Grid item size={6}>
        <ButtonBlueStyle className="variables-confirm"
                          fullWidth variant='contained' 
                          onClick={onClickConfirm}>
          Conferma
        </ButtonBlueStyle>
      </Grid>
    </Grid>
  )
}
